module.exports = __webpack_public_path__ + "static/media/error-warn.67399f33.svg";